export enum ContentDirection{

    HORIZONTAL= 1,
    VERTICAL ,
    DIAGONAL  
}